import { mount } from "svelte";
import "@steyncd/steyn-design/index.css";
import App from "./App.svelte";
import { applyTheme } from "./lib/appearance";

// Theme comes from Fabric's registry, not from this bundle: the household
// asked for per-portal control, and a colour change should not need a rebuild
// and a deploy. Applied synchronously from cache so there is no flash.
applyTheme("homestead");

export default mount(App, { target: document.getElementById("app")! });
